const SortIconDescending = ({ topLetter = "A", bottomLetter = "Z" }) => (
  <svg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g id='Desc-eng'>
      <g id='Group 1522'>
        <g id='Group 1521'>
          <text
            id='topLetter'
            fill='black'
            fillOpacity='0.85'
            xmlSpace='preserve'
            fontFamily='NotoSansSC'
            fontSize='8'
            fontWeight='bold'
            letterSpacing='0.005em'
          >
            <tspan x='9.57031' y='6.22058'>
              {topLetter}
            </tspan>
          </text>
          <text
            id='bottomLetter'
            fill='black'
            fillOpacity='0.85'
            xmlSpace='preserve'
            fontFamily='NotoSansSC'
            fontSize='8'
            fontWeight='bold'
            letterSpacing='0.005em'
          >
            <tspan x='9.57031' y='14.2206'>
              {bottomLetter}
            </tspan>
          </text>
          <path
            id='Subtract'
            d='M4.91699 14.5947C4.93647 14.5852 4.95441 14.5717 4.96777 14.5547L6.96777 12.0205C7.04261 11.9277 6.97408 11.7881 6.85449 11.7881H5.49805V2.32422C5.49805 2.24565 5.43306 2.18066 5.35449 2.18066H4.35449C4.27608 2.18085 4.21191 2.24576 4.21191 2.32422V11.7881H2.85449C2.73506 11.7883 2.66726 11.926 2.74219 12.0205L4.74219 14.5547C4.75548 14.5716 4.77265 14.5853 4.79199 14.5947C4.81138 14.6042 4.83293 14.6093 4.85449 14.6094C4.87604 14.6094 4.8976 14.6041 4.91699 14.5947Z'
            fill='black'
            fillOpacity='0.85'
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SortIconDescending;
